import React from 'react';

import { authenticationService } from 'auth/authenticationService.js'


// Auth Components
export default function PrivateComponent(props) {
  let groups = authenticationService.currentUser.groups
  let haveRole = false;

  // console.log(props)
  if(!props.roles){return null}
  
  let intersection = props.roles.filter(x => groups.includes(x));
  // console.log(intersection);
  intersection.length>0 ? haveRole=true : haveRole=false


  return (
    authenticationService.isAuthenticated &&
    haveRole ?
    (
      <div>
        {props.children}
      </div>
    )
    : null
  );
}
